import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/utils/cn';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  children?: ReactNode;
  shape?: 'square' | 'round';
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ children, shape = 'square', className, checked, ...props }, ref) => {
    return (
      <label className={cn('inline-flex items-center cursor-pointer group', className)}>
        <div className="relative flex items-center justify-center">
          <input ref={ref} type="checkbox" checked={checked} className="sr-only peer" {...props} />
          <div
            className={cn(
              'w-5 h-5 border-2 transition-all',
              'peer-checked:bg-primary peer-checked:border-primary',
              'peer-focus:ring-2 peer-focus:ring-primary/20',
              'group-hover:border-primary/70',
              shape === 'round' ? 'rounded-full' : 'rounded',
              checked ? 'bg-primary border-primary' : 'bg-white border-border-color',
            )}
          >
            {checked && (
              <Check size={14} className="text-white" strokeWidth={3} />
            )}
          </div>
        </div>
        {children && <span className="ml-2 text-sm text-text-primary">{children}</span>}
      </label>
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
